export default __webpack_public_path__ + "static/media/_attention-medium.836b8036.svg";